/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booster_TagInputs */

const en_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost`)
};

const ar_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعزيز`)
};

const de_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost`)
};

const es_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost`)
};

const fr_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost`)
};

const it_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost`)
};

const ja_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブースト`)
};

const ko_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부스트`)
};

const pt_br_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost`)
};

const ru_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Буст`)
};

const th_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บูสต์`)
};

const tr_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takviye`)
};

const zh_cn_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加速`)
};

const zh_tw_booster_tag = /** @type {(inputs: Booster_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加速`)
};

/**
* | output |
* | --- |
* | "Boost" |
*
* @param {Booster_TagInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const booster_tag = /** @type {((inputs?: Booster_TagInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booster_TagInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booster_tag(inputs)
	if (locale === "ar") return ar_booster_tag(inputs)
	if (locale === "de") return de_booster_tag(inputs)
	if (locale === "es") return es_booster_tag(inputs)
	if (locale === "fr") return fr_booster_tag(inputs)
	if (locale === "it") return it_booster_tag(inputs)
	if (locale === "ja") return ja_booster_tag(inputs)
	if (locale === "ko") return ko_booster_tag(inputs)
	if (locale === "pt_br") return pt_br_booster_tag(inputs)
	if (locale === "ru") return ru_booster_tag(inputs)
	if (locale === "th") return th_booster_tag(inputs)
	if (locale === "tr") return tr_booster_tag(inputs)
	if (locale === "zh_cn") return zh_cn_booster_tag(inputs)
	return zh_tw_booster_tag(inputs)
});